/* tslint:disable:component-selector */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form[ccTableHeader]',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
